import React from 'react';
import LinkIcon from '@mui/icons-material/Link';

import { isLoggedInUserRoot } from '@paragon/login-tools';

import { useAppMonitor } from '../../../monitor';
import { generateShareLink } from '../../../store/actions/urlActions';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { ToolbarIconButton } from '../top/ToolbarIconButton';

export default function GenerateLinkButton() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const isRoot = useAppSelector(isLoggedInUserRoot);

  if (!isRoot) return null;
  return (
    <ToolbarIconButton
      icon={<LinkIcon />}
      title="Generate Link (works for your organization)"
      onClick={() => {
        dispatch(generateShareLink());
        monitor.recordInteraction('Component Link Generated');
      }}
    />
  );
}
